export default __webpack_public_path__ + "static/media/icon-union.2731d03c.svg";